import { Controller } from '@nestjs/common';

@Controller('fork-lift-items')
export class ForkLiftItemsController {}
